import { render, staticRenderFns } from "./cms-detail.vue?vue&type=template&id=38ae99e0&"
import script from "./cms-detail.vue?vue&type=script&lang=js&"
export * from "./cms-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports